module.exports = __webpack_public_path__ + "web/img/type-9.6f58e1cc.png";